// removed by extract-text-webpack-plugin
module.exports = {"publisher":"_1pgvfghNfVe1SB8bMdme2t","publisherIcon":"_1S4Kk4LpeCVY0curryEEC8"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/PublisherIcon.scss
// module id = 1569
// module chunks = 0